<template>
  <div class="swiper">
    <el-carousel
      class="swiper-container"
      indicator-position="none"
      @change="changeHandle"
      height="150px">
      <el-carousel-item
        class="slider-item"
        v-for="(item,index) in data.sliders"
        :key="item.src+index">
        <img :src="item.src">
      </el-carousel-item>
    </el-carousel>
    <div class="indicator">
      <span
        v-for="(item,index) in data.sliders"
        :key="'indicator'+index"
        :class="{active:currentIndicator===index}">
      </span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'swiper',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      currentIndicator: 0
    }
  },
  methods: {
    changeHandle (e) {
      this.currentIndicator = e
    }
  }
}
</script>
<style lang="less" scoped>
.swiper {
  width: 100%;
  overflow: hidden;
  background-color: #eee;
  padding: 5px 0;
  position: relative;
  .slider-item {
    img {
      width: 100%;
      height: auto;
    }
  }
  .indicator {
    position: absolute;
    left: 50%;
    bottom: 15px;
    margin-left: -75px;
    z-index: 1000;
    width: 150px;
    display: flex;
    justify-content: center;
    span {
      display: inline-block;
      padding: 3px;
      border-radius: 50%;
      background-color: #eeeeee;
      margin-left: 8px;
      &.active {
        background-color: #409EFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/components/modules/swiper.vue